import {createContext} from "@lit/context";
import type {RuntimeEnvironment} from "@common-core/web-component-runtime/runtime";
import type {Environment} from "./Environment";

export const RuntimeContext =
  createContext<RuntimeEnvironment<Environment, unknown>>("runtime-context");
